module.exports = __webpack_public_path__ + "static/media/OnlineShoppingIcon.bd0efdf1.png";